<style>
  #BtnDiv {
    position: fixed;
    bottom: 25px;
    right: 25px;
    background: #282a39b0;
    padding: 10px;
    border-radius: 5px;
  }
</style>

<div [hidden]="Show_History_View>0" class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Custody Receipt Form</h5>

    <button type="button" *ngIf="Letter_Form_Id=='0'" (click)="openModal_Customer(templateCustomer)"
      class="btn btn-warning" style="margin-right: 5px;"> Search Customers <i class="fa fa-vcard"></i> </button>


    <br />
    <br />

    <div *ngIf="Data_Seleted_Customer.id>0">

      <form>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Letter Number </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Customer Name </label>
            <input type="text" class="form-control" name="name" disabled value="{{Data_Seleted_Customer.name}}" />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Delivered By </label>
            <input type="text" class="form-control" name="Delivery" [(ngModel)]="Delivery" placeholder="Type here..." />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Description </label>
            <input type="text" class="form-control" name="Dsc" [(ngModel)]="Dsc" placeholder="Type here..." />
          </div>
        </div>

      </form>

      <br />
      <hr />
      <br />

      <div>

        <h5> Letter Messages </h5>

        <br />

        <form *ngIf="canEditMainForm" [formGroup]="MailMessageForm" (submit)="MailMessageForm_Submit()">

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> Letter Message </label>
              <select class="custom-select" formControlName="mailmessage_id">
                <option value="0">Select</option>
                <option *ngFor="let item of DataList_MailMessage" [value]="item.id">{{item.title}}</option>
              </select>
            </div>
          </div>

          <button type="submit" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i>
            Add Message </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="FormAdded_MailMessage.length>0">


          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Letter Message</th>
                <th *ngIf="canEditMainForm">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of FormAdded_MailMessage">
                <td>{{FormAdded_MailMessage.indexOf(item)+1}}</td>
                <td>{{item.title}}</td>
                <td style="cursor: pointer;" *ngIf="canEditMainForm">
                  <a style="cursor: pointer;" (click)="MailMessageForm_Delete(FormAdded_MailMessage.indexOf(item))"
                    class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                </td>
              </tr>
            </tbody>
          </table>




        </div>

        <br />
        <br />

      </div>


      <br />
      <hr />
      <br />

      <h5> Equipment </h5>

      <br />
      <br />
      <form *ngIf="canEditMainForm" [formGroup]="DeviceForm" (submit)="DeviceForm_Submit()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"><button type="button" (click)="openModal_Device(templateDevice)"
                class="btn btn-warning left"> Select Instrument <i class="fa  fa-simplybuilt"></i> </button> </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Device_Record.title}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Count</label>
            <input formControlName="tedad" type="number" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_DeviceForm_tedad().valid && get_DeviceForm_tedad().touched"
              class="form-text text-muted MyErrorRedColor">Enter the quantity.</small>
          </div>

        </div>
        <div class="row">

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Description </label>
            <textarea type="text" formControlName="dsc" placeholder="Type here..." class="form-control"></textarea>
          </div>

        </div>
        <button type="submit" [disabled]="!DeviceForm.valid" class="btn btn-success" style="margin-right: 5px;"><i
            class="fa  fa-plus-circle"></i> Add Equipment </button>
      </form>


      <br />
      <br />

      <div class="table-responsive" *ngIf="DeviceFormList.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Name Equipment</th>
              <th>Count</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of DeviceFormList">

              <tr>
                <td>{{DeviceFormList.indexOf(item)+1}}</td>
                <td>{{item.device_name}}</td>
                <td>{{item.tedad}}</td>
                <td>{{item.dsc}}</td>
                <td *ngIf="canEditMainForm && !item.dsc_bazgast">
                  <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" (click)="OpenImageDialog(templateImageForm,item)"
                          class="dropdown-item"><i class="fa fa-cloud-upload"></i> Attachments </a>

                        <a style="cursor: pointer;"
                          (click)="DeleteDeviceFormList_Modal(templateRemoveDevice,DeviceFormList.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>

                        <a *ngIf="item.id>0" style="cursor: pointer;" (click)="OpenBazgasht(templateBazgasht,item)"
                          class="dropdown-item"><i class="fa fa-recycle"></i> Back Instrument </a>
                      </div>
                    </div>
                  </div>
                </td>
                <td *ngIf="item.dsc_bazgast">
                  <p>{{item.dsc_bazgast}}</p>
                </td>
              </tr>

              <tr *ngIf="item.file.length>0">
                <td colspan="5">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #3e399b; color: white;">
                      <tr>
                        <th>#</th>
                        <th>File</th>

                        <th *ngIf="canEditMainForm && !item.dsc_bazgast">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let itemFile of item.file">

                        <td>{{item.file.indexOf(itemFile)+1}}</td>
                        <td>

                          <a target="_blank" *ngIf="itemFile.includes('.pdf')"
                            href="{{BaseURlFile}}File/Letter/{{itemFile}}" class="btn btn-success"><i
                              class="fa fa-file-pdf-o"></i> PDF </a>


                          <img *ngIf="!itemFile.includes('.pdf')" (click)="openModal(templateImage,itemFile)"
                            style="width: 150px;cursor: zoom-in;" src="{{BaseURlFile}}File/Letter/{{itemFile}}" />
                        </td>
                        <td *ngIf="canEditMainForm && !item.dsc_bazgast">
                          <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                            <div class="btn-group" role="group">
                              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Actions
                              </button>
                              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                <a style="cursor: pointer;"
                                  (click)="UploadImageSrc_List_Delete(item.file.indexOf(itemFile),item)"
                                  class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                              </div>
                            </div>
                          </div>
                        </td>

                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

            </ng-container>




          </tbody>
        </table>
      </div>


    </div>


    <br />
    <br />

    <div id="BtnDiv">

      <img *ngIf="Data_Seleted_Customer.id>0 && InProccessing" src="assets/Loading.gif" style="width: 25px;" />

      <ng-container *ngFor="let item of Data_List_Order">

        <button *ngIf="item.submit && !InProccessing" type="button" (click)="OpenOrderDialog(templateOrder,item)"
          [disabled]="DeviceFormList.length==0" [class]="item.cls" style="margin-right: 5px;"> <i
            [class]="item.icon"></i> {{item.title}} </button>
        <button *ngIf="item.hasRefer && !item.submit && !InProccessing" type="button"
          (click)="OpenOrderDialog(templateOrder,item)" [disabled]="DeviceFormList.length==0" [class]="item.cls"
          style="margin-right: 5px;"><i [class]="item.icon"></i> {{item.title}} </button>
        <button *ngIf="!item.hasRefer && !item.submit && !item.copy && !InProccessing" type="button"
          [disabled]="DeviceFormList.length==0" (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls"
          style="margin-right: 5px;"> <i [class]="item.icon"></i> {{item.title}} </button>

      </ng-container>

      <button *ngIf="has_calibration_customer_order && !InProccessing"  type="button" class="btn btn-info" style="margin-right: 5px;"> 
        <i class="fa fa-info-circle"></i> Additional Services Request
      </button>

      <button *ngIf="!InProccessing" (click)="NewForm()" type="button" class="btn btn-info" style="margin-right: 5px;">
        <i class="fa fa-recycle"></i> New Custody Receipt Form </button>
      <button *ngIf="Letter_Form_Id>0 && !InProccessing && canReviewDetail" (click)="ReadHistory_Letter()" type="button"
        class="btn btn-warning" style="margin-right: 5px;"> <i class="fa fa-file-text"></i> Letter Details </button>
      <button *ngIf="Letter_Form_Id>0 && !InProccessing"
        (click)="OpenNoteDialog(templateComment)" type="button" class="btn btn-success" style="margin-right: 5px;"> <i
          class=" fa fa-sticky-note-o"></i> Submit Comment </button>
      <a target="_blank" *ngIf="canDownloadPDF && Letter_Form_Id>0 && !InProccessing && canReviewDetail"
        href="{{BaseUrl}}{{Letter_Form_Id}}" style="margin-right: 5px;" class="btn btn-info"><i
          class="fa fa-file-pdf-o"></i> Pdf </a>

    </div>


    <br />
    <br />



  </div>

</div>

<div *ngIf="Show_History_View==1" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">Letter Details '{{Letter_Form_Code}}'</h5>
        </div>
        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">Referral History</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                aria-controls="months" aria-selected="true">Letter Attachments</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#flowchart" role="tab"
                aria-controls="months" aria-selected="true">Referral Workflow</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <app-LetterRequestCustomerHistory [DataList_History]="DataList_History"></app-LetterRequestCustomerHistory>
          </div>

        </div>
        <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <app-LetterRequestCustomerPeyvast [canOpenPeyvast]="canOpenPeyvast" [DataList_Peyvast]="DataList_Peyvast"></app-LetterRequestCustomerPeyvast>

          </div>
        </div>
        <div class="tab-pane fade show" id="flowchart" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div>
              <app-LetterRequestCustomerTreeHistory [DataList_History]="DataList_History">
              </app-LetterRequestCustomerTreeHistory>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>

  </div>



</div>




<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Customer List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Customer Name </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Behfa Customer Code</th>
              <th>Customer Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Instrument Information List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Instrument Name </label>
          <input type="text" class="form-control" (keyup)="ReadData_Device_KeySearch()"
            [(ngModel)]="Search_Name_Device_Table" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Instrument Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Device
            | paginate
                    : {
                        id: 'DataList_Device',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Device).length
                      }">
              <td>{{DataList_Device.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_Device_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingDevice" type="button" (click)="ReadData_Device()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Letter Number </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Letter Number <b>'{{Letter_Form_Code}}'</b></p>
  </div>
  <div class="modal-body" *ngIf="canShowSendSMS">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Full Name</th>
            <th>Position</th>
            <th>Mobile Number</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Karshnash">
            <td>{{DataList_Karshnash.indexOf(item)+1}}</td>
            <td>
              <span *ngIf="item.sex==1">Mr.</span>
              <span *ngIf="item.sex==0">Ms.</span>
              {{item.fname}} {{item.lname}}
            </td>
            <td>{{item.semat}}</td>
            <td>{{item.mobile}}</td>
            <td>{{item.dsc}}</td>
            <td>
              <button type="button" *ngIf="!item.del" class="btn btn-danger"
                (click)="Change_Selected_Of_Karshnash(item)">Deselect</button>
              <button type="button" *ngIf="item.del" class="btn btn-info" (click)="Change_Selected_Of_Karshnash(item)">
                Select</button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">

    <button type="button" *ngIf="canShowSendSMS" class="btn btn-success" (click)="SendSMS()">Send SMS</button>
    <button type="button" *ngIf="canShowSendSMS" class="btn btn-warning" (click)="SendSMS_NoMatch()">Send SMS Nonconformity</button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateOrder>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Selected_Order_Operation.title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Order.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12" *ngIf="Selected_Order_Operation.hasRefer || Selected_Order_Operation.submit">
        <label for="exampleInputEmail1">Recipient</label>
        <select class="custom-select" [(ngModel)]="SelectedLetterRole">
          <option value="0">Select</option>
          <option *ngFor="let item of Data_list_LetterRole" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input type="text" class="form-control" [(ngModel)]="LetterHistoryDsc" placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="SubmitAddNewLetter_Co(templateCode,Selected_Order_Operation)"> Submit and Register </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Order.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateImageForm>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> File Upload Form </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ImageForm.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group col-md-6">
      <label for="exampleInputEmail1">
        Attachments
        <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
            class="fa  fa-times-rectangle"></i> </button>
      </label>
      <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
      <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
        class="form-control" placeholder="Type here...">
    </div>
  </div>
  <div class="modal-footer">

    <button *ngIf="canEditMainForm" type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ImageForm.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> View Image </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseURlFile}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseURlFile}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> Download </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateBazgasht>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Approve Back Instrument Custody Receipt </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Bazgasht.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input type="text" class="form-control" [(ngModel)]="Dsc_Bazgasht" placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="DeleteBazgashtDevice(0)"> Save </button>
    <button type="button" class="btn btn-info" (click)="DeleteBazgashtDevice(1)"> Save (Send SMS) </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Bazgasht.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateComment>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Submit a New Customer Comment for Customer '{{Data_Seleted_Customer.name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Note.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <textarea type="text" class="form-control" [(ngModel)]="Note_Dsc" placeholder="Type here...">
        </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!InProccessing" class="btn btn-success" (click)="SubmitNote()">
      Submit and Register </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Note.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateRemoveDevice>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Approve Delete Instrument '{{DeleteDeviceFormList_Record.device_name}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeleteDeviceFormList.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="DeleteDeviceFormList()"> Delete Instrument <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_DeleteDeviceFormList.hide()">Close</button>
  </div>
</ng-template>
